import { DataRetentionSettingsActions } from './partials/dataRetention'
import { DocketwiseSettingsActions } from './partials/docketwise'
import { EngagementLetterActions } from './partials/engagementLetter'
import { GenericModelSettingsActions } from './partials/genericModel'
import { InvoicedSettingsActions } from './partials/invoiced'
import { LegalCasePartySliderSettingsActions } from './partials/legalCasePartySlider'
import { LegalCasesSettingsActions } from './partials/legalCases'
import { MaintenanceSettingsActions } from './partials/maintenance'
import { MiscSettingsActions } from './partials/misc'
import { MultifactorAuthenticationSettingsActions } from './partials/multifactorAuthentication'
import { OtherDocketEntriesSettingsActions } from './partials/otherDocketEntries'
import { PermissionsSettingsActions } from './partials/permissions'
import { RecordsSettingsActions } from './partials/records'
import { SessionManagementSettingsActions } from './partials/sessionManagement'
import { SettingsSharedActions } from './partials/shared'
import { SharepointSettingsActions } from './partials/sharepoint'
import { TimezoneSettingsActions } from './partials/timezone'
import { TmetricSettingsActions } from './partials/tmetric'
import { TwilioSettingsActions } from './partials/twilio'
import { UserAccessSettingsActions } from './partials/usersAccess'
import { UserSettingsActions } from './partials/user'
import { WorkflowSettingsActions } from './partials/workflows'

export const SettingsActions = {
  ...DataRetentionSettingsActions,
  ...DocketwiseSettingsActions,
  ...EngagementLetterActions,
  ...GenericModelSettingsActions,
  ...InvoicedSettingsActions,
  ...LegalCasePartySliderSettingsActions,
  ...LegalCasesSettingsActions,
  ...MaintenanceSettingsActions,
  ...MiscSettingsActions,
  ...MultifactorAuthenticationSettingsActions,
  ...OtherDocketEntriesSettingsActions,
  ...PermissionsSettingsActions,
  ...RecordsSettingsActions,
  ...SessionManagementSettingsActions,
  ...SettingsSharedActions,
  ...SharepointSettingsActions,
  ...TimezoneSettingsActions,
  ...TmetricSettingsActions,
  ...TwilioSettingsActions,
  ...UserAccessSettingsActions,
  ...UserSettingsActions,
  ...WorkflowSettingsActions,
}
